import { handleActions } from 'redux-actions';
import * as vehiclesActions from '../actions/vehiclesActions';

let vehiclesState = {
  actualVehicles: [],
  archiveVehicles: [],
  actualFilterVehicles: [],
  archiveFilterVehicles: [],
  vehicleById: null,
  successMessage: '',
  errorMessage: '',
};

export const vehicles = handleActions(
  {
    // Get All Vehicles
    [vehiclesActions.getAllVehicles]: state => {
      return { ...state, isLoading: true };
    },
    [vehiclesActions.getAllVehiclesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        actualVehicles: payload.actualVehicles,
        archiveVehicles: payload.archiveVehicles,
        isLoading: false,
      };
    },
    [vehiclesActions.getAllVehiclesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },

    //Get Filter Vehicles
    [vehiclesActions.getFilterVehicles]: state => {
      return { ...state, isLoading: true };
    },
    [vehiclesActions.getFilterVehiclesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        actualFilterVehicles: payload.actualVehicles,
        archiveFilterVehicles: payload.archiveVehicles,
        isLoading: false,
      };
    },
    [vehiclesActions.getFilterVehiclesError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },

    // get Actual Vehicles
    [vehiclesActions.getActualVehicles]: (state, _action) => {
      return state;
    },
    [vehiclesActions.getActualVehiclesSuccess]: (state, action) => {
      let { payload } = action;
      return { ...state, actualVehicles: payload.data };
    },
    [vehiclesActions.getActualVehiclesError]: (state, action) => {
      let { payload } = action;
      return (state = {
        errorMessage: payload.data.message,
      });
    },
    // get Archive Vehicles
    [vehiclesActions.getArchiveVehicles]: (state, _action) => {
      return state;
    },
    [vehiclesActions.getArchiveVehiclesSuccess]: (state, action) => {
      let { payload } = action;
      return { ...state, archiveVehicles: payload.data };
    },
    [vehiclesActions.getArchiveVehiclesError]: (state, action) => {
      let { payload } = action;
      return (state = {
        errorMessage: payload.data.message,
      });
    },

    //Get Vehicle
    [vehiclesActions.getVehicle]: (state, _action) => {
      return state;
    },
    [vehiclesActions.getVehicleSuccess]: (state, action) => {
      let { payload } = action;
      return (state = {
        ...state,
        vehicleById: payload,
      });
    },
    [vehiclesActions.getVehicleError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
      };
    },
  },
  vehiclesState
);
